import ajax from "./ajax";


class ViewModelApi {
    constructor() { }

    async loadPTOCalendarViewModelAsync() {
        const res = await ajax.vm().get("pto-calendar-view");
        return res.data;
    }
}

const viewModelApi = new ViewModelApi();

export default viewModelApi;